import React from "react";
import { Modal } from "antd";
import LoginRegisterDialog from "./LoginRegisterDialog";

function LoginModal({ isModalVisible, setIsModalVisible, initialState }) {
  return (
    <Modal
      visible={isModalVisible}
      onOk={() => setIsModalVisible(false)}
      onCancel={() => setIsModalVisible(false)}
      footer={null}
      title={null}
      width="auto"
      style={{ maxWidth: "400px", height: "300px" }}
      closable={false}
    >
      <LoginRegisterDialog
        setIsModalVisible={setIsModalVisible}
        initialState={initialState}
      />
    </Modal>
  );
}

export default LoginModal;
